import { API } from "../../../utils";

export const authentication = async (payload) => {
  const res = await API.post("register-bump-screen", payload);
  return res.data;
};
